import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { TaskPriority, TaskStatus } from "../../../__generated__/globalTypes";
import { taskPriorityLabel, taskStatusLabel } from "../../../helpers/enum-labels";

interface ITaskForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const TaskForm: React.FC<ITaskForm> = ({ loading, form, submit }) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Titre"
          className="w-full"
          {...form.register("title", { required: "Titre requis" })}
          placeholder="Relancer le client X"
        />
        <Textarea
          label="Description"
          className="w-full"
          {...form.register("description")}
        />
        <Select label="Statut" className="w-full" {...form.register("status", { required: true })}>
          {Object.keys(TaskStatus).map((status) => (
            <option key={status} value={status}>
              {taskStatusLabel(status)}
            </option>
          ))}
        </Select>
        <Select label="Priorité" className="w-full" {...form.register("priority", { required: true })}>
          {Object.keys(TaskPriority).map((priority) => (
            <option key={priority} value={priority}>
              {taskPriorityLabel(priority)}
            </option>
          ))}
        </Select>
        <Input label="Échéance" type="date" className="w-full" {...form.register("dueDate")} />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
